import { asnStoredStates } from '../../../enums/eAsnState'

// Paleta compartida por el aviso del header y el detalle de los modales, para
// que "almacenada" y "pendiente" se lean igual en toda la pantalla.
// Es la misma que usa CustomAlert para success y warning.
export const getRelatedAsnPalette = (asnStateId: number) => {
  const isStored = asnStoredStates.includes(asnStateId)

  return {
    isStored,
    text: isStored ? '#2e7d32' : '#e65100',
    background: isStored ? '#e8f5e9' : '#fff3e0',
    border: isStored ? '#4caf50' : '#ffc107',
    icon: isStored ? '#4caf50' : '#ff9800'
  }
}
